<template>
  <div class="grading">
    <div class="header">
      <div class="top">
        <div class="title">
          围棋等级考试
        </div>
      </div>
    </div>
    <div class="container">
      <div class="grading_header">
        <div class="slip"></div>
        <div class="title">考试须知</div>
      </div>
      <div class="grading_content">
<!--        <div class="item_title">一、报考对象</div>-->
        <!-- <div class="item_cons">1、根据考试级别不同，考试题目设为10-20道不等。</div>
        <div class="item_cons">2、每级考试时限为30分钟。</div> -->
        <div class="item_cons">1、通过标准：正确率60%及以上，题目形式为选择题和实操题。</div>
        <div class="item_cons">2、参加考试的同学务必独立答题，家长和老师不得提示指导。</div>
        <div class="item_cons">3、特殊说明：考生出现以下情况不退还考试费。</div>
        <!-- <div class="item_cons"></div> -->
        <div class="item_conses">①报名后无法按规定时间参加考试</div>
        <div class="item_conses">②考试不合格，即未通过考试</div>
        <!-- <div class="item_conses"></div> -->
        <div class="chess">
          <img src="../../assets/imgs/go.png">
        </div>
        <div class="confirmbox"  @click="confrim">
          <el-checkbox v-model="checked">我已阅读并接受本网站报考须知</el-checkbox>
        </div>
        <div class="confrimBtn">
          <el-button type="primary" :disabled="isDisable" @click="submit">确认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goNotice',
  data () {
    return {
      checked: false,
      isDisable: true
    }
  },
  created () {
    var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
    var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    if (isIE) {
      var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
      reIE.test(userAgent)
      var fIEVersion = parseFloat(RegExp['$1'])
      if (fIEVersion === 7) {
        this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
      } else if (fIEVersion === 8) {
        this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
      } else if (fIEVersion === 9) {
        this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
      } else if (fIEVersion === 10) {
        this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
      } else {
        this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
      }
    } else if (isEdge) {
      return 'edge' // edge
    } else if (isIE11) {
      this.$message.error('当前浏览器为IE浏览器，请使用非IE浏览器进行考级！')
    } else {
      return -1 // 不是ie浏览器
    }
  },
  mounted () {
  },
  methods: {
    confrim () {
      console.log('this.checked', this.checked)
      if (this.checked === true) {
        this.isDisable = true
        console.log('this.isDisable', this.isDisable)
      } else {
        this.isDisable = false
        console.log('this.isDisable', this.isDisable)
      }
    },
    submit () {
      let screenWidth = window.screen.width
      // let screenHeight = document.body.clientHeight
      console.log(screenWidth)
      if (screenWidth < 768) {
        this.$message({
          message: '请在电脑或者笔记本上考试',
          center: true,
          type: 'warning'
        })
      } else {
        this.$router.push('/gotest')
        // this.$router.push('/chessTest')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .header{
    width:100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    height: 140px;
    background-color: #008EE9;
    .top{
      width: 100%;
      @media only screen and (min-width: 540px) and (max-width: 1180px){
        width: 1180px;
      }
      height: 140px;
      @include flex();
      padding: 0 95px;
      margin: 0 auto;
      box-sizing: border-box;
      .title{
        background-color: #008de9;
        color: #fff;
        font-size: 50px;
        font-family: 'SimSun';
        font-weight: bold;
      }
      .login{
        width: 185px;
        height: 75px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .container{
    margin-bottom: 50px;
    .grading_header{
      width: 100%;
      margin-top: 60px;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      .slip{
        width: 15px;
        height: 50px;
        background: #008EE9;
        line-height: 70px;
      }
      .title{
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #008EEA;
        line-height: 70px;
        margin-left: 30px;
      }
    }
    .grading_content{
      width: 100%;
      border: 1px solid #9A9A9A;
      padding: 40px;
      box-sizing: border-box;
      .item_title{
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #343434;
        line-height: 32px;
      }
      .item_cons{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #343434;
        line-height: 35px;
      }
      .chess{
        margin-top: 30px;
      }
      .item_conses{
        text-indent: 1em;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      .confirmbox{
        width: 100%;
        margin: auto;
        margin-top: 30px;
        text-align: center;
        .el-checkbox{
          color: #000;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
        }
      }
      .confrimBtn{
        width: 100%;
        margin: auto;
        margin-top: 30px;
        text-align: center;
        .el-button{
          width: 127px;
          height: 52px;
          border-radius: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/go_test/goNotice.vue